import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Level from './Level'
import Team from './Team'

export default class extends Resource {
  static name = 'client'

  static get fields () {
    return {
      id: new UUID(),
      description: new STRING(),
      key: new STRING(),
      secret: new STRING(),
      role: new ITEM(Level),
      team: new ITEM(Team),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_a: new DATETIME()
    }
  }
}
